<template>
  <div v-loading.sync.fullscreen="loading">
    <div>
      <el-form ref="search-form" :model="query" label-width="80px" inline size="small">
        <el-form-item class="label-inline" label="关注项" prop="concerned"
                      :rules="[{validator: checkConcernedSelected, message: '查询前必须选择关注项'}]">
          <el-select filterable :value="query.concerned.title" placeholder="请选择"
                     @change="concernedChange"
                     :remote-method="searchConcerned" remote class="inline-input">
            <el-option :label="c.title" v-for="c in concernedList" :key="c.id" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="label-inline" label="时间" prop="time">
          <el-select v-model="query.timeType" class="inline-input">
            <el-option label="当天" value="1"></el-option>
            <el-option label="两天内" value="2"></el-option>
            <el-option label="三天内" value="3"></el-option>
            <el-option label="四天内" value="4"></el-option>
            <el-option label="五天内" value="5"></el-option>
            <el-option label="六天内" value="6"></el-option>
            <el-option label="七天内" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="label-inline" label="标题" prop="title">
          <el-input v-model="query.title" placeholder="输入过滤标题" class="inline-input"></el-input>
        </el-form-item>
        <el-form-item class="text-center" label=" ">
          <el-button icon="el-icon-search" type="primary" size="small" @click="doSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
        <el-pagination v-if="searched" small :total="page.totalElements" :page-size="page.size"
                       layout="prev, pager, next, ->, total" :current-page="page.number"
                       :page-count="page.totalPages" @current-change="setNumberAndSearch"></el-pagination>
    </div>
    <div>
      <div v-for="(item, idx) in items" :key="item.url" style="margin: 8px 0">
        <daily-report-item-card :item="item" :index="idx + 1" :highlight-titles="highlightTitles"></daily-report-item-card>
      </div>
    </div>
    <div v-if="this.page.totalPages > 0">
        <el-pagination v-if="searched" small :total="page.totalElements" :page-size="page.size"
                       layout="prev, pager, next, ->, total" :current-page.sync="page.number"
                       :page-count="10" @current-change="setNumberAndSearch"></el-pagination>
    </div>
  </div>
</template>

<script>
import ConcernedInfo from "@/models/ConcernedInfo";
import Page from "@/models/Page";
import ConcernedInfoService from "@/services/concernedInfo/ConcernedInfoService";
import SearchService from "@/services/searchService/SearchService";
import DailyReportItem from "@/models/DailyReportItem";
import DailyReportItemCard from "@/components/daily/DailyReportItemCard";

export default {
  name: "SearchComponent",
  components: {DailyReportItemCard},
  data() {
    return {
      query: {
        title: '',
        concerned: new ConcernedInfo(),
        timeType: "1"
      },
      concernedCount: 0,
      concernedList: [],
      loading: false,
      items: [],
      page: new Page({number: 1}),
      searched: false
    }
  },
  mounted() {
    this.fetchConcernedList()
  },
  computed: {
    highlightTitles() {
      if (this.query.concerned && this.query.concerned.includeWords) {
        return this.query.concerned.includeWords.split(",")
      }
      return []
    }
  },
  methods: {
    setNumberAndSearch(n) {
      this.page.number = n
      this.doSearch()
    },
    doSearch() {
      this.$refs['search-form'].validate((v) => {
        if (v) {
          this.loading = true
          this.searched = true
          SearchService.searchByConcerned(this.query.concerned.id, this.query.timeType, {number: this.page.number - 1, size: this.page.size})
              .then(resp => {
                if (resp.status === 200) {
                  this.page = new Page({
                    number: resp.data.number + 1,
                    size: resp.data.size,
                    totalElements: resp.data.totalElements,
                    totalPages: resp.data.totalPages
                  })
                  this.items = (resp.data.content || []).map(i => new DailyReportItem(i))
                }
              })
              .finally(() => this.loading = false)
        }
      })
    },
    searchConcerned(wd) {
      if (!wd) {
        return
      }
      this.title = wd
      this.fetchConcernedList()
    },
    fetchConcernedList() {
      const page = new Page({number: 0})
      this.loading = true
      ConcernedInfoService.fetchSelfInfos({title: this.title, ...page}).then(resp => {
        if (resp.status === 200) {
          const pg = new Page(resp.data)
          this.concernedList = resp.data.content.map(c => new ConcernedInfo(c))
          this.concernedCount = pg.totalElements
          if (this.concernedList.length > 0) {
            this.query.concerned = new ConcernedInfo(this.concernedList[0])
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    checkConcernedSelected(r, v, cb) {
      if ((!this.query) || (!this.query.concerned) || (!this.query.concerned.id)) {
        cb(Error(r.message))
        return
      }
      cb()
    },
    concernedChange(c) {
      this.query.concerned = new ConcernedInfo(c)
    }
  }
}
</script>

<style scoped>

</style>
